module.exports = __webpack_public_path__ + "img/telemedicina-pet.557c1dd6.jpeg";